var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethroughAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.22984C6.25 3.47955 8.47955 1.25 11.2298 1.25H13C15.6234 1.25 17.75 3.37665 17.75 6V6.1282C17.75 6.54242 17.4142 6.8782 17 6.8782C16.5858 6.8782 16.25 6.54242 16.25 6.1282V6C16.25 4.20507 14.7949 2.75 13 2.75H11.2298C9.30798 2.75 7.75 4.30798 7.75 6.22984C7.75 7.2355 8.18507 8.19199 8.94311 8.85285L9.9722 9.75H7.70742C6.77751 8.81961 6.25 7.55453 6.25 6.22984Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.134 14.25H12.8513L15.2986 16.3835C15.9031 16.9105 16.25 17.6732 16.25 18.4751C16.25 20.0076 15.0076 21.25 13.4751 21.25H11C9.20507 21.25 7.75 19.7949 7.75 18V16.8462C7.75 16.4319 7.41421 16.0962 7 16.0962C6.58579 16.0962 6.25 16.4319 6.25 16.8462V18C6.25 20.6234 8.37665 22.75 11 22.75H13.4751C15.8361 22.75 17.75 20.8361 17.75 18.4751C17.75 17.2397 17.2155 16.0647 16.2843 15.2529L15.134 14.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.25C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H22C22.4142 12.75 22.75 12.4142 22.75 12C22.75 11.5858 22.4142 11.25 22 11.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethroughAlt);
export default __webpack_public_path__ + "static/media/strikethrough-alt.23f982f89707b966eb1271f78d696055.svg";
export { ForwardRef as ReactComponent };